module.exports = __webpack_public_path__ + "img/edit.27062af5.svg";